import React from "react"
import { useQuery } from "react-query"
import LoadingSpinner from "../../../common/spinner/loading.component"
import PaymentStatsHelper from "../../../payment-account/service/paymentStatsHelper"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { useGetPaymentAccounts } from "../../usePaymentAccountSession"
import StatBoxInTransitToBank from "./StatBoxInTransitToBank"
import StatBoxLastPayout from "./StatBoxLastPayout"
import StatboxBalance from "./StatboxBalance"

const PayoutStatBoxes = () => {

    const { merchantID } = useGetPaymentAccounts()

    const { data: paymentStats, isLoading } = useQuery(["paymentStats"], async () => {
        return await PaymentStatsHelper.getPaymentStats(merchantID, INTEGRATION_KEY.RAINFOREST)
    })
    
    if (!paymentStats || isLoading) {
        return <LoadingSpinner />
    }

    return (
        <div className="stat-box-container gap-3">
            <StatboxBalance amount={paymentStats.balance} currency={paymentStats.currency}/>
            <StatBoxInTransitToBank amount={paymentStats.inTransitToBank} currency={paymentStats.currency}/>
            <StatBoxLastPayout amount={paymentStats.lastPayout} currency={paymentStats.currency}/>
        </div>
    )
}

export default PayoutStatBoxes


// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/statBoxes/PayoutStatBoxes.tsx